import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=ee094ace&scoped=true&"
import script from "./Registry.vue?vue&type=script&lang=js&"
export * from "./Registry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee094ace",
  null
  
)

export default component.exports